import React, { MouseEventHandler, useContext } from 'react';
import { BackArrowIcon } from 'assests/GmsIcons';
import { useNavigate } from "react-router";
import { AppContext } from 'Context/AppContext';
import { RECOMMENDER_UPDATE } from '../ARSConstants';
import { RecommenderLogsResponse } from '../Types';

type TARSPageHeaderProps = {
    model: RecommenderLogsResponse,
    onSave: () => void
    onEditClick?: MouseEventHandler<HTMLButtonElement> | undefined;
    togglePromoteModal: () => void
}

const ARSPageHeader = ({ model, onSave }: TARSPageHeaderProps) => {
    const navigate = useNavigate();
    const appData = useContext(AppContext);
    const updatePermission = appData.pm.checkPermission(RECOMMENDER_UPDATE);

    return (
        <React.Fragment>
            <div className={`tw-flex tw-py-1.5 tw-items-center tw-bg-shades-of-grey-10`}>
                <div role="button" data-testid="components-arspageheader-div-1" className='tw-flex tw-gap-4 tw-items-center' onClick={() => navigate('/gms/commend', { replace: true })}>
                    <BackArrowIcon />
                    <label className={`tw-text-black tw-text-[24px] tw-font-semibold`}>{model?.model_name ?? ''}</label>
                </div>
                <div className="tw-h-6 tw-px-2.5 tw-py-[3px] tw-bg-white tw-rounded tw-border tw-border-[#969fae] tw-justify-start tw-items-center tw-gap-1 tw-inline-flex tw-ml-4">
                    <div className={`tw-w-[11.25px] tw-h-[11.25px] ${model?.promotion_status.status === "Promoted" ? "tw-bg-green-300" : "tw-bg-red-300"}  tw-rounded-sm`}></div>
                    <div className="tw-text-center tw-text-black tw-text-xs  tw-leading-[18px]">{model?.promotion_status.status === "Promoted" ? "Promoted" : "Not Promoted"}</div>
                </div>
                <div className='tw-ml-4'>
                    <div className="tw-text-blue-950 tw-text-sm  tw-leading-tight">{model?.applet_name} </div>
                </div>
                <div className='tw-flex-1' />
                <div className='tw-flex tw-gap-2'>
                    <button data-testid="components-arspageheader-button-1" onClick={onSave} disabled={model?.promotion_status.status === "Promoted" || !updatePermission} className='button-style'>{'Update'}</button>
                </div>
            </div>
        </React.Fragment >
    );
}

export default ARSPageHeader